import { useMutation, useQueryClient } from "@tanstack/react-query";
import { stergeTargetareTinta } from "@/api/endpoints/targetareTinte";
import { queryKeys } from "@/lib/queryClient";

export function useStergeTargetareTinta() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: stergeTargetareTinta,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.targetare.tinte() });
      queryClient.invalidateQueries({
        queryKey: queryKeys.targetare.activitate(),
      });
    },
  });
}
